import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavbarComp from "./components/nav-bar/NavbarComp";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./Context/LanguageContext";
import HomePage from "./Pages/Home/HomePage";
import AboutUs from "./Pages/AboutUs/AboutUs";
import WhyUs from "./Pages/WhyUs/WhyUs";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import FooterComp from "./components/Footer/FooterComp";
import OurOfferings from "./Pages/OurOfferings/OurOfferings";
import TechnologyExpertise from "./Pages/TechnologyExpertise/TechnologyExpertise";
import BackendDeveloper from "./Pages/BackendDeveloper/BackendDeveloper";
import Careers from "./Pages/Careers/Careers";
import Loader from "./components/Loader/Loader";
import Discover from "./Pages/DiscoverMorePage/DiscoverMorePage";
import PrivacyPage from "./Pages/PrivacyPage/PrivacyPage";
import JobApplication from "./Pages/JobApplication/JobApplication";
import TechExpertisetab from "./components/TechExpertiseTabs/TechExpertiseTabs";
import TandC from "./Pages/TermsAndConditions/TandC";
import ScrollToTop from "./components/ScrollToTop";
import SystemApplicationsEngineer from "./Pages/SystemApplicationDeveloper/SystemApplicationsEngineer";
import ComputerVisionEngineer from "./Pages/ComputerVisionEngineer/ComputerVisionEngineer";
import InteropEngineer from "./Pages/InteropEngineer/InteropEngineer";
import ChatWidget from "./components/ChatWidget/ChatWidget";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <LoaderWrapper />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </LanguageProvider>
  );
}
const LoaderWrapper = () => {
  // const [loading] = useState(false);

  return (
    <>
      <>
        <NavbarComp />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/whyus" element={<WhyUs />} />
          <Route path="/ourofferings" element={<OurOfferings />} />
          <Route
            path="/technologyexpertise"
            element={<TechnologyExpertise />}
          />
          <Route path="/careers" element={<Careers />} />
          <Route path="/loader" element={<Loader />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/t&c" element={<TandC />} />
          <Route path="/jobs" element={<JobApplication />} />
          <Route path="/jobs/:jobName" element={<JobApplication />} />

          <Route path="/discover/:cardName" element={<Discover />} />
          <Route path="/tabs" element={<TechExpertisetab />} />
          <Route path="/jobs/backend" element={<BackendDeveloper />} />
          <Route path="/jobs/uisystem" element={<SystemApplicationsEngineer />} />
          <Route path="/jobs/computer" element={<ComputerVisionEngineer />} />
          <Route path="/jobs/interop" element={<InteropEngineer />} />
        </Routes>

        <FooterComp />
        <ChatWidget />
      </>
    </>
  );
};

export default App;
